// extracted by mini-css-extract-plugin
module.exports = {"container":"BranchCell_container__8B8dl","highlighted":"BranchCell_highlighted__wBce9","details":"BranchCell_details__9lk_U","isOpenable":"BranchCell_isOpenable__QF6VS"};